import { SessionManagementTable } from './SessionManagementTable';
export default SessionManagementTable;
